import { createSelector } from 'reselect'
import jwtDecode from 'jwt-decode'

export const getLogin = createSelector(
  [
    state => state.admin.login,
  ],
  login => login,
)

export const getLoginError = state => state.admin.loginError


export const getUser = createSelector(
  [
    state => state.admin.jwt,
  ],
  (jwt) => {
    const user = (jwt && jwtDecode(jwt))

    if (user && ('exp' in user)) {
      if (user.exp > (Date.now() / 1000)) {
        return user
      }
    }
    return false
  },
)


export const getJwt = createSelector(
  [
    state => state.admin.jwt,
  ],
  jwt => jwt,
)


export const getActiveNode = createSelector(
  [
    object => object.state,
    object => object.nodes,
  ],
  (state, nodes) => nodes && nodes.find(node => node.id === state.admin.activeNode),
)


export const getSteps = createSelector(
  [
    state => state.admin.steps,
  ],
  steps => steps.filter(step => step.activated),
)

export const getStepsForUser = createSelector(
  [getUser, getSteps],
  (user, steps) => (user.role !== 'Admin' ? steps.filter(step => !step.restricted) : steps),
)



// WEBPACK FOOTER //
// ./src/modules/admin/selectors.js